/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetUsersOptions, AdminGetUsersResponses } from '../../models/AdminGetUsers'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary List Users
 * {@link /admin/users}
 */
export function adminGetUsers<ThrowOnError extends boolean = true>(options: Options<AdminGetUsersOptions, ThrowOnError> = {}): Promise<UnwrappedResult<AdminGetUsersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/users', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetUsersResponses, ThrowOnError>>
}
